import '@/utils/flexible.js';
import { createApp } from 'vue';
// svg插件解决jsx中使用svg https://github.com/oliverfindl/vue-svg-inline-plugin
import VueSvgInlinePlugin from 'vue-svg-inline-plugin';
import App from './App.vue';
// import "./registerServiceWorker";
import router from './router';
import store from './store';

import '@/utils/buried-point';

createApp(App).use(VueSvgInlinePlugin).use(store).use(router).mount('#app');
